import React from 'react'
import StudentInfo from './StudentInfo'

const StudentIndex = () => {
  return (
    <StudentInfo />
  )
}

export default StudentIndex